"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRTCUtils = void 0;
const logger_1 = require("./logger");
class WebRTCUtils {
    constructor() {
        (0, logger_1.configureARaaSClientSDKLogger)(logger_1.logger);
    }
    static queryCodecCapabilities(codecType) {
        let codecs = RTCRtpSender.getCapabilities(codecType).codecs || [];
        let codecMimes;
        codecs.forEach(codec => {
            codecMimes.push(codec.mimeType);
        });
        return codecMimes;
    }
}
exports.WebRTCUtils = WebRTCUtils;
//# sourceMappingURL=webrtc_utils.js.map